import { PagedResult, Result, ResourceItem } from "./../models/index";
import { ServiceBase } from './ServiceBase';

export class SearchIn {
    keywords: string;
    category: string;
    country: string;
    searchBy: string;
    caseStudiesTreeOrder: boolean;
    culture: string;

    constructor() {
        this.keywords = '';
        this.category = '';
        this.country = '';
    }

    public static fromInput(input: Partial<SearchIn>) {
        var result = new SearchIn();
        result = { ...result, ...input };
        return result;
    }
}

export class ResourcesService extends ServiceBase {

    public static async search(filters: SearchIn, pageSize: number, offset: number): Promise<Result<PagedResult<ResourceItem>>> {

        let searchDto = filters;

        let payload = { ...searchDto, pageSize, offset };

        var result = await this.requestJson<PagedResult<ResourceItem>>({
            url: `/api/search/SearchResources`,
            method: "POST",
            data: payload
        });

        return result;
    }
}
